export enum EmailMessageContentType {
  HTML = 'text/html',
  PLAIN = 'text/plain',
  BOX_FILE_ID = 'application/cap-box-file-id',
}
